import { z } from 'zod';

export const RefIndustries = z.object({
  code: z.string(),
  referential_id: z.string().uuid(),
  name: z.string(),
  created_at: z.string(),
  updated_at: z.string(),
});

export type RefIndustriesT = z.infer<typeof RefIndustries>;

export const RefIndustriesInsert = RefIndustries.partial();

export type RefIndustriesInsertT = z.infer<typeof RefIndustriesInsert>;

export const RefIndustriesUpdate = RefIndustries.partial();

export type RefIndustriesUpdateT = z.infer<typeof RefIndustriesUpdate>;
